import petimg from '@/assets/img/user-default-icon.png';
import './UserDetails.scss';
type UserListProps = {
  user: any;
  showIdentity?: boolean;
  showPrimaryLabel?: boolean;
  isAssistant?: boolean;
};
export const UserDetails: React.FC<UserListProps> = ({
  user,
  showIdentity = false,
  showPrimaryLabel,
  isAssistant = false,
}) => {
  const name = isAssistant ? user.firstName + ' ' + user.lastName : user.name;
  const avatarUrl = isAssistant ? user.avatar_url : user.avatarUrl;
  return (
    <div className="user-detail-card">
      <div className="left-image-holder">
        <img
          referrerPolicy="no-referrer"
          src={avatarUrl ? avatarUrl : petimg}
          style={{ border: user?.color ? `3px solid ${user.color}` : '3px solid #f85663' }}
        />
      </div>
      <div className="user-details-div">
        <div className="right-details">
          <div>
            <p className="name" title={name}>
              {name}{' '}
            </p>
            {showPrimaryLabel && user?.isPrimary && <span className="primary-user">Primary</span>}
          </div>

          <p className="email">{user?.isLocal ? ' ' : user?.email}</p>
        </div>
        {showIdentity && (
          <div className="indentity">
            {/* { item.selected ? <img src={ ListCheck } className="ListCheck" /> : null } */}
            You
          </div>
        )}
      </div>
    </div>
  );
};
